export enum CommunicationType {
  chat = 'chat',
  text = 'text',
  incomingPhoneCall = 'incomingPhoneCall',
}
